import { Link } from "react-router-dom";
import styled from "styled-components";

export const CMDiv = styled.div`
  width: 100%;
  display: flex;
  align-itemns: flex-end;
  flex-direction: column;
  text-align: left;
  & .MuiFormControl-root input {
    width: 100% !important;
}
  & label {
    color: #6e6d6d;
  }
  & .butonContactUs {
    width:1rem;
  }
  & .CUSmessage {
    width: 23.5rem;     
    height: 8rem; 
     resize: vertical;  
    overflow-x: hidden;
    border: 1px solid rgba(128, 128, 128, 0.5);
  }
  & .password-field {
    & span {
      position: relative;
      width: 100%;
      background: transparent;
      justify-content: left;
    }
     
  }
     & .Row{
      display:flex;
      flex-direction:row;
      width:100%;
      gap:1.5%;
      }

      & .Column{
      display:flex;
      flex-direction:column;
      width:40%;

      label {
    display: block;
  }

  .form-label {
    
    display: block;
  }

  input{
    box-sizing: border-box;
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    height: auto !important;
    min-height: 40px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-clip: padding-box;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    border: 1px solid #ddd;
    border-radius: 0;

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  .inputPassword {
    span {
      max-height: 38px;
      top: 9px;
      right: 1px;


    }
  }

  .MuiFormControl-root {
    input {
      font-size: 14px;
    }
  }
   
}
 
   

}
.ColumnTextArea{
display: flex;
flex-direction: column;
text-align: left;
width: 100%;
margin-bottom:20px;
gap:8px;
}

.textarea{
  width: 81.5%;

  }

 .File {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
 

`;

export const CMLink = styled.div(props => ({
  position: 'absolute',
  top: '5vw',
  right: '15vw',
}));
